(ns minorodata.components.pipeline-editor.analytics-model
  (:require
   ["@xyflow/react" :refer [ReactFlowProvider]]
   ["allotment" :refer [Allotment]]
   ["react" :as react]
   [applied-science.js-interop :as jsi]
   [goog.functions :refer [debounce]]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.pipeline-editor.dag :refer [subdag]]
   [minorodata.components.pipeline-editor.details.core :refer [details]]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]
   [ui.drawer]))


(defn fetch-analytics-model-dag [dag-id filters]
  (dispatch [:pipeline-editor.events/set-dag-filter {:params (merge {:id dag-id} filters)}]))

(defn dag [{:keys [dag-data instance-id]}]
  [:div {:class "h-full"}
   [:f> subdag {:id            instance-id
                :dag-data      dag-data
                :apply-filters #(fetch-analytics-model-dag (:id dag-data) %)}]])


(defn analytics-model-page' [{:keys [instance-id selected dag-data panel-state]}]
  (let [panel-ref     (react/useRef nil)
        initial-sizes (react/useMemo (fn [] (js->clj (:sizes panel-state))) #js [])]

    (react/useEffect
     (fn []
       (jsi/call-in panel-ref [:current :resize] (clj->js (cond-> (:sizes panel-state)
                                                            (= 3 (count (:sizes panel-state)))
                                                            next)))
       js/undefined)
     #js [(:sizes panel-state)])

    [:> Allotment {:ref           panel-ref
                   :vertical      true
                   :default-sizes (cond-> initial-sizes
                                    (= 3 (count initial-sizes))
                                    next)
                   :on-change     (debounce #(let [sizes (js->clj %)
                                                   sizes (cond-> sizes
                                                           (= 3 (count sizes))
                                                           next)]
                                               (when (not= sizes (:sizes panel-state))
                                                 (dispatch [:pipeline-editor.events/set-panel-sizes sizes])))
                                            200)}
     [:> Allotment.Pane {:min-size       150
                         :preferred-size "50%"
                         :snap           true
                         :class "relative"}
      [dag {:dag-data    dag-data
            :instance-id instance-id}]]
     [:> Allotment.Pane {:min-size       200
                         :preferred-size "50%"
                         :snap           true}
      [details {:selected selected}]]]))


(defn analytics-model-page [{:keys [master-id group-id] :as props}]
  (let [panel-state @(re-posh/subscribe [:pipeline-editor.subs/panel])
        sandbox?    @(re-posh/subscribe [:sandbox.subs/enabled?])
        dag-data    @(re-posh/subscribe [:pipeline-editor.subs/dag master-id :model sandbox?])
        query       @(re-frame/subscribe [:app-route/prop :app-route/query])]

    [:> ReactFlowProvider
     [:f> analytics-model-page' (assoc props
                                       :instance-id  master-id
                                       :panel-state  panel-state
                                       :dag-data     dag-data
                                       :selected     (if (:tab-preview-type query)
                                                       {:type     (:tab-preview-type query)
                                                        :id       (:tab-preview-id query)
                                                        :group-id (:tab-preview-group-id query)
                                                        :preview  true}
                                                       {:type     "model"
                                                        :id       master-id
                                                        :group-id group-id}))]]))
